import React, { Fragment, useEffect, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { Button, FormGroup, Row, Col } from 'reactstrap';
import DataReactTableAsignAdvance from './DataReactTableAsignAdvance';
import { formatNumber } from '../../../Utils/Money';
import Spinner from 'react-bootstrap/Spinner';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faMinus } from "@fortawesome/free-solid-svg-icons";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ModalAlert from '../../../../shared/components/Modal';
import moment from 'moment';


const no_op = () => { };
const ModalFormAddPaymentToInvoices = ({ advancedPayment, isOpen = false, setIsOpen = no_op }) => {
    const [load, setLoad] = useState(false);
    const [invoicesData, setInvoicesData] = useState(null);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [invoicesPayedByAdvancedPayment, setInvoicesPayedByAdvancedPayment] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [isLoadingGetInvoicesPayed, setIsLoadingGetInvoicesPayed] = useState(false);
    const [totalAdvancedPayment, setTotalAdvancedPayment] = useState({ incomeAdvance: advancedPayment ? advancedPayment.valor : 0, distribured: 0, left: 0 }); //valor restante
    const [mountBySelectedInvoices, setMountBySelectedInvoices] = useState({ incomeAdvance: advancedPayment ? advancedPayment.valor : 0, accTotalInvoices: 0 })
    const [dataSendToPaymentHistory, setDataSendToPaymentHistory] = useState({ id_anticipo: parseInt(advancedPayment?.id_anticipo), facturas: [] });
    const [totalPaymentsByAdvanced, setTotalPaymentsByAdvanced] = useState(0);
    const [timer, setTimer] = useState(null)

    const [onDeletePayment, setOnDeletePayment] = useState(false);
    const [idPagoToDelete, setIdPagoToDelete] = useState('')
    const [modalAlert, setModalAlert] = useState({ title: '', color: '', message: '' });

    useEffect(() => {
        if (advancedPayment !== null && advancedPayment !== undefined) {
            checkInvoicesThird();
        }
    }, [advancedPayment]);

    const checkInvoicesThird = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/revisar-facturas-paciente?id_tercero=' + advancedPayment.id_tercero, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("FACTURAST", data);
                if (data?.facturas) {
                    //setInvoicesData(data.facturas);
                    filterInvoicesFromParticular(data.facturas)
                }
                else {
                    setInvoicesData(null);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    const getInvoicesPayedByAdvancedPayment = () => {
        return new Promise((resolve, reject) => {
            setIsLoadingGetInvoicesPayed(true);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo-historial/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("AdvancedPayments", data);
                    if (data) {
                        resolve(data);
                        //setInvoicesPayedByAdvancedPayment(data);
                    }
                    else {
                        resolve(data);
                        //setInvoicesData([]);
                    }
                    setIsLoadingGetInvoicesPayed(false);
                })
                .catch((error) => {
                    setIsLoadingGetInvoicesPayed(false);
                    console.error('Error:', error);
                });
        })

    }

    const savePaymentsHistory = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo-historial/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSendToPaymentHistory)
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
                else {
                    throw new Error(response.text());
                }
            })
            .then(data => {
                setSelectedInvoices([]);
                checkInvoicesThird();
                setDataSendToPaymentHistory({
                    ...dataSendToPaymentHistory, facturas: []
                })
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    //filtra las facturas que son del tercero
    const filterInvoicesFromParticular = async (wholeInvoices) => {
        let invoices = wholeInvoices.filter((invoice) => invoice.tipo !== 1);
        let filteredInvoices = invoices.filter((invoice) => invoice.estado_pago !== 3 && invoice.estado_pago !== 5);
        setInvoicesData(filteredInvoices);

        //Determinar cuales facturas ya estan pagas por el Anticipo
        let getPayedInvoicesByAdvanced = await getInvoicesPayedByAdvancedPayment();
        let filterPaymetsFromCurrentAdvanced = getPayedInvoicesByAdvanced.filter((pay) => pay.id_anticipo === parseInt(advancedPayment.id_anticipo))
        let invoicesPayedBythrid = [];
        filterPaymetsFromCurrentAdvanced.length ? filterPaymetsFromCurrentAdvanced.forEach((historyPayed) => {
            if (historyPayed.facturas.hasOwnProperty('detalles')) {
                historyPayed.facturas.detalles.forEach((invoice) => {
                    if (invoice.id_tercero === advancedPayment.id_tercero) {
                        invoicesPayedBythrid.push(invoice);
                        setTotalPaymentsByAdvanced((prevState) => prevState + parseInt(invoice.monto_distribuido));
                    }
                })
            } else if (historyPayed.facturas.hasOwnProperty('facturas')) {
                historyPayed.facturas.facturas.forEach((invoice) => {
                    if (invoice.id_tercero === advancedPayment.id_tercero) {
                        invoicesPayedBythrid.push(invoice);
                        setTotalPaymentsByAdvanced((prevState) => prevState + parseInt(invoice.monto_distribuido));
                    }
                })
            }
        }) : [];
        let calculateValuesDistributed = calculateValuesAdvance(invoicesPayedBythrid);
        setTotalAdvancedPayment((prevState) => { return { ...prevState, distribured: calculateValuesDistributed, left: Math.abs(advancedPayment.valor - calculateValuesDistributed) } });
        setInvoicesPayedByAdvancedPayment(invoicesPayedBythrid);
    }

    const calculateValuesAdvance = (invoicesPayedBythrid) => {
        let totalvalueDistributed = 0;
        if (invoicesPayedBythrid) {
            totalvalueDistributed = invoicesPayedBythrid.reduce((acc, current) => acc + parseInt(current.monto_distribuido), 0);
        }
        return totalvalueDistributed;
    }

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }

    const stateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return 'POR PAGAR';
            } else if (parseInt(stateInvoice) === 2) {
                return 'PAGADA PARCIALMENTE';
            } else if (parseInt(stateInvoice) === 3) {
                return 'PAGADA COMPLETAMENTE';
            } else if (parseInt(stateInvoice) === 4) {
                return 'RETRASADA';
            } else if (parseInt(stateInvoice) === 5) {
                return 'SOBREPAGO';
            }
        } else {
            return 'POR PAGAR';
        }
    }
    const colorStateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return '#0084CF';
            } else if (parseInt(stateInvoice) === 2) {
                return '#FFA600';
            } else if (parseInt(stateInvoice) === 3) {
                return '#48CF00';
            } else if (parseInt(stateInvoice) === 4) {
                return '#FF2D00';
            } else if (parseInt(stateInvoice) === 5) {
                return '#6B00CF';
            }
        } else {
            return '#0084CF';
        }
    }

    const invoiceTotal = (invoice) => {
        let total = 0
        let totalFac = calculateTotal(invoice);
        total = totalFac !== null && totalFac !== undefined ? totalFac.total_tercero : 0;

        return total;
    }

    const getTotalPaymentsByInvoice = (invoice) => {
        let accPaymentsToInvoice = 0;
        if (invoice) {
            if (invoice.hasOwnProperty('pagos')) {
                accPaymentsToInvoice = invoice.pagos.reduce((acc, current) => acc + current.importe, 0);
            }
        }
        return accPaymentsToInvoice;
    }

    const reactTableDataAdvancedPayment = {
        tableHeaderData: [{
            Header: 'FAC.',
            accessor: 'num_fac_ter',
            //disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <label>{row.value}</label>
            )
        },
        {
            Header: 'ESTADO',
            accessor: 'estado_pago',
            Cell: row => (
                <div>
                    <label style={{ color: colorStateInvoice(row.value) }}>{stateInvoice(row.value)}</label>
                </div>
            )
        },
        {
            Header: 'VALOR',
            accessor: 'valor',
            Cell: row => (
                <label>${formatNumber(invoiceTotal(row.row.original))}</label>
            ),
        },
        ],
        tableRowsData: invoicesData
    };

    const onSelectednvoice = (invoice) => {
        //setMountBySelectedInvoices --> Montos de las facturas seleccionadas
        let totalInvoice = invoiceTotal(invoice); // total de la factura
        let totalPaymentsByInvoice = getTotalPaymentsByInvoice(invoice); // total pagos hechos a la factura

        let totalToPay = Math.abs(totalInvoice - totalPaymentsByInvoice);


        let invoiceDataInfo;
        if (invoicesData) {
            invoiceDataInfo = invoicesData;
            let newInvoiceData = invoiceDataInfo.filter((inv) => inv.id_factura_t !== invoice.id_factura_t);
            setInvoicesData(newInvoiceData);
        }
        setSelectedInvoices((prevState) => { return [...prevState, invoice] });

        let invoicesToSend = dataSendToPaymentHistory.facturas;

        if (totalAdvancedPayment.left - totalToPay < 0) {
            let newTotalToPay = totalToPay - Math.abs(totalAdvancedPayment.left - totalToPay);
            setMountBySelectedInvoices((prevState) => { return { ...prevState, accTotalInvoices: mountBySelectedInvoices.accTotalInvoices + newTotalToPay } })
            setTotalAdvancedPayment((prevState) => { return { ...prevState, left: totalAdvancedPayment.left - newTotalToPay, distribured: totalAdvancedPayment.distribured + newTotalToPay } })
            setDataSendToPaymentHistory({
                ...dataSendToPaymentHistory, facturas: [...invoicesToSend, {
                    id_factura_t: invoice.id_factura_t,
                    num_fac_ter: invoice.num_fac_ter,
                    monto_distribuido: newTotalToPay,
                    id_tercero: invoice.id_tercero
                }]
            })
        } else {
            setMountBySelectedInvoices((prevState) => { return { ...prevState, accTotalInvoices: mountBySelectedInvoices.accTotalInvoices + totalToPay } })
            setTotalAdvancedPayment((prevState) => { return { ...prevState, left: totalAdvancedPayment.left - totalToPay, distribured: totalAdvancedPayment.distribured + totalToPay } })
            setDataSendToPaymentHistory({
                ...dataSendToPaymentHistory, facturas: [...invoicesToSend, {
                    id_factura_t: invoice.id_factura_t,
                    num_fac_ter: invoice.num_fac_ter,
                    monto_distribuido: totalToPay,
                    id_tercero: invoice.id_tercero
                }]
            })
        }
    }


    const onToggleToDropInvoiceFromSelected = (invoice) => {
        if (invoicesData) {
            let newInvoicesData = [...invoicesData, invoice];
            let organized = organizeInvoices(newInvoicesData);
            setInvoicesData(organized);
        }
        let selectedOldInvoices = selectedInvoices;
        let newSelectedInvoices = selectedOldInvoices.filter((inv) => inv.id_factura_t !== invoice.id_factura_t);
        setSelectedInvoices(newSelectedInvoices);

        let invoicesToSend = dataSendToPaymentHistory.facturas;
        let newInvoicesToSend = invoicesToSend.filter((inv) => inv.id_factura_t !== invoice.id_factura_t);
        setDataSendToPaymentHistory({
            ...dataSendToPaymentHistory, facturas: newInvoicesToSend
        })

        let getInvoiceToDrop = invoicesToSend.find((pay) => pay.id_factura_t === invoice.id_factura_t);
        let valueToDrop = parseInt(getInvoiceToDrop.monto_distribuido)
        let totalSelectedInvoices = invoicesToSend.reduce((acc, current) => acc + parseInt(current.monto_distribuido), 0);
        console.log('totalSelectedInvoices', totalSelectedInvoices, 'valueToDrop', valueToDrop);
        if (totalAdvancedPayment.left === 0) {
            setMountBySelectedInvoices((prevState) => { return { ...prevState, accTotalInvoices: totalSelectedInvoices } })
            setTotalAdvancedPayment((prevState) => {
                return {
                    ...prevState,
                    left: totalAdvancedPayment.incomeAdvance - totalAdvancedPayment.distribured + valueToDrop,
                    distribured: totalAdvancedPayment.distribured - valueToDrop
                }
            })
        } else {
            setMountBySelectedInvoices((prevState) => { return { ...prevState, accTotalInvoices: totalSelectedInvoices } })
            setTotalAdvancedPayment((prevState) => {
                return {
                    ...prevState,
                    left: totalAdvancedPayment.incomeAdvance - totalAdvancedPayment.distribured + valueToDrop,
                    distribured: totalAdvancedPayment.distribured - valueToDrop
                }
            })
        }
    }

    const organizeInvoices = invoices => {
        const size = invoices.length;
        let j, temp;

        for (let i = 1; i < size; i++) {
            j = i;
            temp = invoices[i];
            while (j > 0 && moment(invoices[j - 1].fecha_emision).isAfter(temp.fecha_emision)) {
                invoices[j] = invoices[j - 1];
                j--;
            }
            invoices[j] = temp;
        }
        return invoices;
    };

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                setOnDeletePayment(!onDeletePayment);
                break;
            case "warning":
                onDeletPayment();
                break;
        }
    }

    const onToggleToDeletePayment = (id_pago) => {
        setIdPagoToDelete(id_pago);
        setOnDeletePayment(true);
        setModalAlert({ title: 'Advertencia', color: 'warning', message: '¿Deseas eliminar este pago?' });
    }

    const onDeletPayment = () => {
        setOnDeletePayment(false);
        let dataSend = { id_pago: idPagoToDelete };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    console.log(response);
                    checkInvoicesThird();
                    setModalAlert({ title: 'Acción completada', color: 'success', message: 'El pago fue eliminado' });
                    return response.json();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    const onChangeTheValueToPayInvoice = (index, valueToPay) => {
        let wholeInvoicesSelected = selectedInvoices;
        let newValueToPay = parseInt(valueToPay);
        console.log('newValueToPay', newValueToPay)

        let invoicesToSend = dataSendToPaymentHistory.facturas;
        invoicesToSend[index].monto_distribuido = newValueToPay;
        let findInvoice = wholeInvoicesSelected.find((inv) => inv.id_factura_t === invoicesToSend[index].id_factura_t);
        let totalInvoice = invoiceTotal(findInvoice);
        let totalPaymentsInvoice = getTotalPaymentsByInvoice(findInvoice);

        let totalToSend = totalInvoice - totalPaymentsInvoice - newValueToPay;
        setDataSendToPaymentHistory({
            ...dataSendToPaymentHistory, facturas: invoicesToSend
        });

        clearTimeout(timer);

        let totalSelectedInvoices = invoicesToSend.reduce((acc, current) => acc + parseInt(current.monto_distribuido), 0);
        setMountBySelectedInvoices((prevState) => { return { ...prevState, accTotalInvoices: totalSelectedInvoices } })
        console.log()
        const newTimer = setTimeout(() => {
            setTotalAdvancedPayment((prevState) => {
                return {
                    ...prevState,
                    left: totalAdvancedPayment.incomeAdvance - totalSelectedInvoices - totalPaymentsByAdvanced,
                    distribured: totalSelectedInvoices + totalPaymentsByAdvanced
                }
            })
        }, 2000)

        setTimer(newTimer)


    }

    const ChargeInvoices = () => {
        return (<DataReactTableAsignAdvance
            reactTableData={reactTableDataAdvancedPayment}
            onSelectednvoice={onSelectednvoice}
            totalAdvancedPayment={totalAdvancedPayment}
        //refresh={getAdvancePayments}
        />)
    }
    return (
        <Fragment>
            <Modal
                open={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                disableEnforceFocus={true}
            >
                <div className="modal-show-info-responsive">
                    <Row>
                        <div className='top-info-advance-payment'>
                            <div className='title'>
                                <h4>Asignar Anticipo a Facturas</h4>
                                {totalAdvancedPayment.left <= 0 ?
                                    <p>No se pueden asignar más pagos a facturas con este anticipo</p>
                                    : null}
                            </div>
                            <div className='info-advance-payment'>
                                <div className='item-info'>
                                    <h4>Total Anticipo</h4>
                                    <h3>${formatNumber(totalAdvancedPayment.incomeAdvance)}</h3>
                                </div>
                                <div className='item-info'>
                                    <h4>Faltante</h4>
                                    <h3>${formatNumber(totalAdvancedPayment.left)}</h3>
                                </div>
                                <div className='item-info'>
                                    <h4>Distribuido</h4>
                                    <h3>${formatNumber(totalAdvancedPayment.distribured)}</h3>
                                </div>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <Col md={6} xs={12}>
                            <div className='info'>
                                <div className='info-add-invoice'>
                                    {selectedInvoices &&
                                        selectedInvoices.length > 0 ?
                                        <Fragment>
                                            <div className='info-selected-invoices'>
                                                <div>
                                                    <h5>Total de Facturas seleccionadas</h5>
                                                </div>
                                                <div className='mount-selected-invoices'>
                                                    <h4>${formatNumber(mountBySelectedInvoices.accTotalInvoices)}</h4>
                                                </div>
                                            </div>
                                            <hr />
                                            {selectedInvoices.map((invoice, i) => (
                                                <div key={invoice.num_fac_ter} className='item-info-add-invoice'>
                                                    <div className='title-info-add-invoice'>
                                                        <div>
                                                            <h4>{invoice.num_fac_ter}</h4>
                                                        </div>
                                                        <div>
                                                            <Tooltip title="Quitar Factura">
                                                                <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '0.8em', height: '0.8em', marginRight: '0.25em' }}
                                                                    //disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                                                    onClick={() => {
                                                                        onToggleToDropInvoiceFromSelected(invoice);
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faMinus} style={{ color: '#153365', width: '0.5em', height: '0.8em' }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                    <div className='top-info-selected-invoice-to-pay'>
                                                        <div className='textfield-income'>
                                                            <TextField
                                                                label="Monto"
                                                                value={dataSendToPaymentHistory.facturas[i]?.monto_distribuido}
                                                                onChange={(event) => {
                                                                    onChangeTheValueToPayInvoice(i, event.target.value);
                                                                }}
                                                                type="number"
                                                                className="medical-material-form__field"
                                                            /* error={errors.hasOwnProperty("concepto") ? errors.concepto !== "" : false}
                                                            helperText={errors.concepto} */
                                                            />
                                                        </div>
                                                        <div className='info-invoice'>
                                                            <h5>Total Factura:</h5>
                                                            <h4>${formatNumber(invoiceTotal(invoice))}</h4>
                                                        </div>
                                                        <div className='info-invoice'>
                                                            <h5>Pagado:</h5>
                                                            <h4>${formatNumber(getTotalPaymentsByInvoice(invoice))}</h4>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            ))}
                                            <div className='button-send-info'>
                                                <Button
                                                    style={{ marginRight: 10, marginTop: 10 }}
                                                    color="primary"
                                                    size="sm"
                                                    id="sendInfoInvoices"
                                                    onClick={() => {
                                                        savePaymentsHistory();
                                                    }}
                                                >
                                                    Asignar
                                                </Button>
                                            </div>
                                        </Fragment>
                                        :
                                        <div className="info-empty">
                                            <div>
                                                <h5>No se ha seleccionado ninguna factura</h5>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='section-invoices-payed'>
                                <div className='title-section'><h5>Facturas pagadas con este Anticipo:</h5></div>
                                {invoicesPayedByAdvancedPayment.length ?
                                    invoicesPayedByAdvancedPayment.map(invoice => (
                                        <Accordion key={invoice.id_pago} expanded={expanded === `panel${invoice.id_pago}`} onChange={handleChange(`panel${invoice.id_pago}`)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                //onClick={() => searchEventFromClinicHistoryComplete(evento_c.id_admision)}
                                                aria-controls={`panel${invoice.id_pago}-content`}
                                                id={`panel${invoice.id_pago}-header`}
                                            >
                                                <div className='title'>
                                                    <div className='num-invoice'><p>{invoice.num_fac_ter}</p></div>
                                                    <div className='num-payment'><p>Pago No. {invoice.id_pago}</p></div>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className='item-invoice-payed-by-advanced'>
                                                    <div className='item-invoice-payed'>
                                                        <h4>Valor: ${formatNumber(invoice.monto_distribuido)}</h4>
                                                    </div>
                                                    <div>
                                                        <Tooltip title="Eliminar Pago">
                                                            <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em', marginRight: '0.25em' }}
                                                                //disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                                                onClick={() => {
                                                                    onToggleToDeletePayment(invoice.id_pago);
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} style={{ color: '#153365', width: '0.8em', height: '0.8em' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </div>

                                            </AccordionDetails>
                                        </Accordion>
                                    ))
                                    :
                                    <div className="info-empty">
                                        <div>
                                            <h5>No hay facturas pagadas hasta el momento</h5>
                                        </div>
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col md={6} xs={12}>
                            <div className='info'>
                                {load ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : invoicesData &&
                                        invoicesData.length > 0 ?
                                        <div className='display-invoices-table'>
                                            <div className='title-table'><h5>Facturas a Pagar</h5></div>
                                            <div className='table-customizable'>
                                                <ChargeInvoices />
                                            </div>
                                        </div>
                                        :
                                        <div className="info-empty">
                                            <div>
                                                <h5>No hay facturas que pagar</h5>
                                            </div>
                                        </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>

            </Modal>
            {onDeletePayment ?
                <ModalAlert
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={onDeletePayment}
                    onOk={() => onOkModal()}
                    toggle={() => { setOnDeletePayment(!onDeletePayment) }}
                />
                : null}
        </Fragment>
    )
}

export default ModalFormAddPaymentToInvoices